var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('codemirror',{ref:"myCm",attrs:{"options":{
            theme: 'darcula',
            lineNumbers: true,
            lineWrapping: true,
        }},model:{value:(_vm.yamlText),callback:function ($$v) {_vm.yamlText=$$v},expression:"yamlText"}})}
var staticRenderFns = []

export { render, staticRenderFns }